import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../i18n';
import { Menu, Bell } from 'lucide-react';
import CompanySwitcher from '../../components/component.companySwitcher';

// Map des routes vers les titres de page
const pageTitles = (t) => ({
  '/dashboard': t.nav.dashboard,
  '/products': t.nav.products,
  '/purchases': t.nav.purchases,
  '/sales': t.nav.sales,
  '/campaigns': t.nav.campaigns,
  '/investments': t.nav.investments,
  '/partners': t.nav.partners,
  '/cagnotte': t.nav.cagnotte,
  '/companies': t.nav.companies,
  '/profile': t.nav.profile,
});

export default function Navbar({ sidebarCollapsed, onMobileMenuToggle }) {
  const { t, locale, toggleLocale } = useTranslation();
  const user = useSelector(s => s.userReducer.user);
  const location = useLocation();
  const navigate = useNavigate();

  const titles = pageTitles(t);
  const currentTitle = titles[location.pathname] || 'SavInvest';

  const initials = user
    ? `${(user.prenom || user.nom || 'U')[0]}${(user.nom || '')[0] || ''}`.toUpperCase()
    : 'U';

  const roleLabel = user?.role === 'investisseur' ? '💼 Investisseur' : '🤝 Partenaire';

  return (
    <header className={`navbar-top ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      {/* Left */}
      <div className="navbar-left">
        {/* Hamburger mobile */}
        <button
          className="btn btn-ghost mobile-menu-btn"
          onClick={onMobileMenuToggle}
          aria-label="Menu"
        >
          <Menu size={22} />
        </button>
        <h1 className="navbar-title">{currentTitle}</h1>
        {/* Company Switcher — visible pour tous les utilisateurs connectés */}
        {user && user.id && <CompanySwitcher />}
      </div>

      {/* Right */}
      <div className="navbar-right">
        {/* Language Toggle */}
        <div className="lang-toggle">
          <button
            className={`lang-btn ${locale === 'fr' ? 'active' : ''}`}
            onClick={() => locale !== 'fr' && toggleLocale()}
            aria-label="Français"
          >
            FR
          </button>
          <button
            className={`lang-btn ${locale === 'en' ? 'active' : ''}`}
            onClick={() => locale !== 'en' && toggleLocale()}
            aria-label="English"
          >
            EN
          </button>
        </div>

        {/* Notifications (placeholder) */}
        <button className="btn btn-ghost" aria-label="Notifications" title="Notifications">
          <Bell size={18} />
        </button>

        {/* User avatar + info */}
        <div
          className="navbar-user"
          onClick={() => navigate('/profile')}
          title="Mon Profil"
        >
          <div className="navbar-user-info">
            <div style={{ fontSize: '0.8125rem', fontWeight: 600, color: 'var(--text-primary)' }}>
              {user?.prenom} {user?.nom}
            </div>
            <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>{roleLabel}</div>
          </div>
          {user?.photo ? (
            <img
              src={user.photo}
              alt={`${user?.prenom} ${user?.nom}`}
              className="user-avatar"
              style={{ objectFit: 'cover', padding: 0 }}
            />
          ) : (
            <div className="user-avatar">
              {initials}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}